import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    currentMonth: Number
  }

  connect() {
    this.scrollToCurrentMonth()
  }

  scrollToCurrentMonth() {
    const monthButtons = this.element.querySelectorAll('a')
    const currentMonthButton = monthButtons[this.currentMonthValue - 1]

    if (currentMonthButton) {
      const containerWidth = this.element.offsetWidth
      const buttonOffset = currentMonthButton.offsetLeft
      const buttonWidth = currentMonthButton.offsetWidth
      const scrollPosition = buttonOffset - (containerWidth / 2) + (buttonWidth / 2)

      this.element.scrollLeft = scrollPosition
    }
  }
} 